import React from 'react';
import PropTypes from 'prop-types';
import PureRender from '../../Common/Utilities/Decorators/PureRenderDecorator.js';
import ClassNames from 'classnames';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators.js';

class MessageView extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        messages: PropTypes.arrayOf(PropTypes.string),
        icon: PropTypes.string,
        severity: PropTypes.oneOf(['', 'information', 'success', 'failure', ]),
        closeable: PropTypes.bool,
        onClose: PropTypes.func
    }

    static defaultProps = {
        severity: '',
        closeable: true,
        onClose: Function.prototype //noop
    }

    constructor(props) {
        super();

        this.assertPropsAreValid(props);
    }

    render() {
        const { title, messages, icon} = this.props
        return (
            <div className={ ClassNames('ui', this.getSeverityClassName(), {icon: icon}, 'message') }>
                {
                    this.props.icon ?
                    <i className={ ClassNames(icon, "icon") }></i> :
                    null
                }
                {
                    this.props.closeable ? (<i className="close icon" onClick={ this.onCloseButtonClick }></i>) : null
                }
                <div className="content">
                    <div className="contentWrapper">
                        {title ? (<h5 className="header">{ title }</h5>) : null }
                        {
                            this.props.children ?
                                this.props.children :
                                messages.length > 1 ?
                                    this.renderMessageList() :
                                    this.renderSingleMessage()
                        }
                    </div>
                </div>
            </div>
        );
    }

    assertPropsAreValid({ messages, children }) {
        if(!children && messages.length < 1)
            throw new Error("'Messages' must contain at least one element.");
    }

    componentDidUpdate(prevProps) {
        this.assertPropsAreValid(this.props);
    }

    renderMessageList(){
        const { messages } = this.props;
        return(
            <ul>
            {   messages.map((message, index) => (<li key={ message + index }>{ message }</li>)) }
            </ul>
        );
    }

    renderSingleMessage(){
        const { messages } = this.props;
        const message = messages[0];

        return (<p>{ message }</p>);
    }

    getSeverityClassName(){
        const { severity } = this.props;

        switch(severity.toLowerCase()) {
            case 'information':
                return  'info';

            case 'success':
                return 'positive';

            case 'failure':
                return 'error';

            default:
                return null;
        }
    }

    onCloseButtonClick = event => {
        this.props.onClose();
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(MessageView);
